import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { LoginFormComponent } from "./login-form.component";

@NgModule({
  declarations: [LoginFormComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [LoginFormComponent],
})
export class LoginFormModule {}
